import {Controller} from '@hotwired/stimulus';

export default class extends Controller {
    showSuccessMessage(e) {
        this.element.insertAdjacentHTML(
            'beforeend',
            `<div class="snickerbar-item snickerbar-success" data-turbo-temporary>
            <span class="snickerbar-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M470.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L192 338.7 425.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg>
            </span>
            <span class="snickerbar-message">${e.detail.message}</span>
            <span class="snickerbar-close" data-action="click->snickerbar#close">
                <i class="custom-icon xmark-solid w-2 h-2 bg-white inline-block"></i>
            </span>
        </div>`
        );

        let lastMessage = this.element.querySelector('div.snickerbar-success:last-of-type');
        setTimeout(() => {
            lastMessage.remove();
        }, e.detail.duration);
    }

    showErrorMessage(e) {
        this.element.insertAdjacentHTML(
            'beforeend',
            `<div class="snickerbar-item snickerbar-error" data-turbo-temporary>
            <span class="snickerbar-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 512"><path d="M96 64c0-17.7-14.3-32-32-32S32 46.3 32 64V320c0 17.7 14.3 32 32 32s32-14.3 32-32V64zM64 480c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40s17.9 40 40 40z"/></svg>
            </span>
            <span class="snickerbar-message">${e.detail.message}</span>
            <span class="snickerbar-close" data-action="click->snickerbar#close">
                <i class="custom-icon xmark-solid w-2 h-2 bg-white inline-block"></i>
            </span>
        </div>`
        );

        let lastMessage = this.element.querySelector('div.snickerbar-error:last-of-type');
        setTimeout(() => {
            lastMessage.remove();
        }, e.detail.duration);
    }

    close(e) {
        e.currentTarget.parentNode.remove();
    }
}
